import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import PromotionList from '../components/Promotions/PromotionList';
import EditPromotion from '../components/Promotions/EditPromotion';
import ViewPromotion from '../components/Promotions/ViewPromotion';


const Promotions = () => {
  return (
    <Routes>
      <Route path="/" element={<PromotionList />} />
      <Route path="/edit/:id" element={<EditPromotion />} />
      <Route path="/edit" element={<EditPromotion />} />
      <Route path="/view/:id" element={<ViewPromotion />} />
    </Routes>
  )
}

export default Promotions;